var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Termo ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Termo*",
      "maxlength": "50",
      "outlined": "",
      "counter": "50",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Tipo do Termo*",
      "items": _vm.form.lists.tiposDeTermo,
      "item-text": 'descricao',
      "item-value": 'id',
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.tipo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "tipo", $$v);
      },
      expression: "content.tipo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.cadastrarTipoTermo = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("mdi-plus-circle")]), _c('strong', [_vm._v("Adicionar um novo tipo de termo")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "label": "Data Início*",
      "dataEdicao": _vm.content.dataInicio,
      "removeIcon": "",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.content.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataInicio", $$v);
      },
      expression: "content.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "dataEdicao": _vm.content.dataFim,
      "label": "Data Fim*",
      "removeIcon": "",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.content.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataFim", $$v);
      },
      expression: "content.dataFim"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mr-4"
  }, [_vm._v("Ações*:")]), _vm.content ? _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.content.acao.id,
      callback: function ($$v) {
        _vm.$set(_vm.content.acao, "id", $$v);
      },
      expression: "content.acao.id"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, _vm._l(_vm.itemsRadioButtomAcoes, function (n) {
    return _c('v-radio', {
      key: n.id,
      staticClass: "mr-4",
      attrs: {
        "value": n.id,
        "label": n.descricao
      }
    });
  }), 1)]) : _vm._e()], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-editor-html', {
    model: {
      value: _vm.content.conteudo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "conteudo", $$v);
      },
      expression: "content.conteudo"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": _vm.salvar,
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1), _c('DialogNovoTipo', {
    attrs: {
      "visible": _vm.cadastrarTipoTermo
    },
    on: {
      "update:visible": function ($event) {
        _vm.cadastrarTipoTermo = $event;
      },
      "confirmarNovoTipo": _vm.adicionarNovoTipo
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }